import React from 'react';

import {EventDescriptionGenerationController, EventReviewFeedback} from 'src/modules/ai';
import {HighlighterWrapper} from 'src/modules/event-review/highlighter/highlighter-wrapper';
import {useIsInReviewStatus} from 'src/modules/event-review/hooks/useIsInReviewStatus';
import {HighlightFields} from 'src/modules/event-review/typedefs';
import {ChangeRequest} from 'src/openapi/models/ChangeRequest';
import {EventDetailInfo} from 'src/openapi/models/EventDetailInfo';

import {EllipsisTextHint} from '@pb/kit-component-ellipsis-text-hint';
import {Group, Item} from '@pb/kit-component-group';

type Props = {
    changeRequest: ChangeRequest,
    eventCodeInfo: EventDetailInfo | null,
    highlightsInfo: Record<HighlightFields, boolean> | null,
};

export const EventDescription = (props: Props) => {
    const {
        changeRequest,
        eventCodeInfo,
        highlightsInfo,
    } = props;

    const isInReviewStatus = useIsInReviewStatus(changeRequest);

    return (
        <Group direction="v" gap="xxs" justify="space-between">
            <Group>
                <strong>Event Description:</strong>
                <EventReviewFeedback changeRequestId={changeRequest.id} fieldName={HighlightFields.description}/>
            </Group>
            <Group>
                <Item style={{minWidth: 0}}>
                    <HighlighterWrapper
                        actualValue={eventCodeInfo?.description || ''}
                        changeRequestValue={changeRequest.event?.description || ''}
                        highlight={!!highlightsInfo?.[HighlightFields.description]}>
                        <Group>
                            <EllipsisTextHint>
                                <span>{changeRequest.event?.description || ''}</span>
                            </EllipsisTextHint>
                        </Group>
                    </HighlighterWrapper>
                </Item>
                {isInReviewStatus ? (
                    <EventDescriptionGenerationController eventChangeRequest={changeRequest.event}/>
                ) : null}
            </Group>
        </Group>
    );
};
